import InstrumentIcon from "../instrument-icon";
import {useTranslation} from "react-i18next";
import {Tooltip} from "react-tooltip";
import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import RankIcon from "../rank-icon";
import {useSelector} from "react-redux";
import Big from "big.js";
import stringHelper from "../../helpers/string-helper";

const TipChatMessage = props => {

    const {fiatRates, selectedFiat} = useSelector(state => state.authenticationReducer)
    const navigate = useNavigate()
    const {message} = props
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const [details, setDetails] = useState({})

    const [theCode, setTheCode] = useState('')
    const [theAmount, setTheAmount] = useState('')
    const [resultCode, setResultCode] = useState('')
    const [resultAmount, setResultAmount] = useState('')
    const [searchParams, setSearchParams] = useSearchParams()
    const handleDetail = () => {
        if (message?.tip_id || details?.tip_id) {
            searchParams.append('modal', message?.tip_id || details?.tip_id)
            setSearchParams(searchParams)
        }
    }

    useEffect(() => {

        if ('details' in message) {
            setDetails(JSON.parse(message['details']))
        }
    }, [message])

    useEffect(() => {
        if (selectedFiat && theAmount && theCode) {
            // console.log('NEW AMOUNT = ', Big(theAmount || 0).div(fiatRates[theCode] || 1).toFixed(2))
            setResultAmount(Big(theAmount || 0).div(fiatRates[theCode] || 1).toFixed(2))
            setResultCode(selectedFiat)

        } else {
            setResultAmount(theAmount)
            setResultCode(theCode)
        }


    }, [fiatRates, theCode, theAmount])


    useEffect(() => {
        setTheCode(message.code || details?.code)
    }, [message.code, details?.code])


    useEffect(() => {
        setTheAmount(message?.amount || details?.amount)
    }, [message?.amount, details?.amount])

    return (
        <div className="chat__message chat__message--tip">
            <div>
                        <span className="chat__user">

                            <Tooltip className="tooltip-me" anchorSelect={`#rank-tooltip`}>
                                <span className="xtable__coin gap-2">
                                    {message?.rank}
                                </span>
                              </Tooltip>

                            {
                                message?.ranki &&
                                <span id="rank-tooltip">
                                  <RankIcon icon={message?.ranki}/>
                               </span>
                            }

                            <button
                                onClick={e =>
                                    navigate(stringHelper.getModalPathStatistics('statistics', message?.from || details?.from, searchParams))
                                }
                                className="chat__name"
                                type="button">
                                @{message?.from || details?.from}
                              </button>
                        </span>

                <span className="chat__tipped">{t('chat.tipped')}</span>
                <button onClick={e =>
                    navigate(stringHelper.getModalPathStatistics('statistics', message?.to || details?.to,searchParams))
                }
                        className="chat__reply">
                    @{message?.to || details?.to}
                </button>
            </div>
            <button className="chat__btn" onClick={handleDetail}>
                            <span className="chat__coin gap-2">
                                {/*<InstrumentIcon code={message.code || details?.code}/>*/}
                                <InstrumentIcon code={resultCode}/>
                                {/*<span>{message?.amount || details?.amount}</span>*/}
                                <span>{resultAmount}</span>

                                {
                                    selectedFiat &&
                                    <InstrumentIcon code={theCode}/>
                                }

                            </span>
            </button>
        </div>
    )
}

export default TipChatMessage
